import { number, struct } from 'io-ts/Decoder';

export const Point = struct({
	x: number,
	y: number,
});
